import React, { Component } from "react";
import { connect } from "react-redux";
import { Spin } from "antd";

import { deleteDemande, loadDemandes } from "../../store/actions/demandeAction";
import { loadLocataires, saveLocataire } from "../../store/actions/locataireAction";
import { loadLots } from "../../store/actions/lotAction";
import { loadRubriques } from "../../store/actions/rubriqueAction";
import { saveRequete } from "../../store/actions/requeteAction";
import { saveRequeteLot } from "../../store/actions/requeteLotAction";
import { saveDossier, updateDossier } from "../../store/actions/dossierAction";
import { saveRecherche } from "../../store/actions/rechercheAction";
import { saveRenduA } from "../../store/actions/renduAction";
import { saveLocation } from "../../store/actions/locationAction";

import ListDemandes from "../../components/ListDemandes";
import { saveLocationLigne } from "../../store/actions/locationLigneAction";

class Demandes extends Component {
  componentDidMount() {
    this.props.loadDemandes();
    this.props.loadLocataires();
    this.props.loadLots();
    this.props.loadRubriques();
  }

  render() {
    const {
      utilisateur,
      demandes,
      qualites,
      locataires,
      lots,
      groupes,
      langues,
      provenances,
      parcoursClients,
      parametre,
      rubriques,
    } = this.props;

    return (
      <Spin spinning={!demandes || !locataires} size="large" tip="Chargement en cours..." wrapperClassName="view-spin">
        <ListDemandes
          utilisateur={utilisateur}
          listData={demandes && demandes.sort((a, b) => b.id - a.id)}
          qualites={qualites}
          locataires={locataires
            ?.filter((loc) => loc.locataire_personne.personne_actif === true)
            .sort((a, b) => a.locataire_code.localeCompare(b.locataire_code))}
          lots={lots}
          groupes={groupes}
          provenances={provenances}
          parcoursClients={parcoursClients}
          parametre={parametre}
          rubriques={rubriques}
          langues={langues}
          deleteDemande={this.props.deleteDemande}
          saveLocataire={this.props.saveLocataire}
          saveRequete={this.props.saveRequete}
          saveRenduA={this.props.saveRenduA}
          saveRequeteLot={this.props.saveRequeteLot}
          saveRecherche={this.props.saveRecherche}
          saveDossier={this.props.saveDossier}
          saveLocation={this.props.saveLocation}
          saveLocationLigne={this.props.saveLocationLigne}
          updateDossier={this.props.updateDossier}
          addPanesRequete={this.props.addPanesRequete}
        />
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadDemandes: () => dispatch(loadDemandes()),
    deleteDemande: (id) => dispatch(deleteDemande(id)),
    loadLocataires: () => dispatch(loadLocataires()),
    loadLots: () => dispatch(loadLots()),
    loadRubriques: () => dispatch(loadRubriques()),
    saveLocataire: (jsonData) => dispatch(saveLocataire(jsonData)),
    saveRequete: (jsonData) => dispatch(saveRequete(jsonData)),
    saveRenduA: (jsonData) => dispatch(saveRenduA(jsonData)),
    saveRequeteLot: (jsonData) => dispatch(saveRequeteLot(jsonData)),
    saveRecherche: (jsonData) => dispatch(saveRecherche(jsonData)),
    saveDossier: (jsonData) => dispatch(saveDossier(jsonData)),
    saveLocation: (jsonData) => dispatch(saveLocation(jsonData)),
    saveLocationLigne: (jsonData) => dispatch(saveLocationLigne(jsonData)),
    updateDossier: (jsonData, idLot) => dispatch(updateDossier(jsonData, idLot)),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    langues: state.langues.data,
    demandes: state.demandes.data,
    qualites: state.qualites.data,
    locataires: state.locataires.data,
    lots: state.lots.data,
    groupes: state.groupes.data,
    provenances: state.provenances.data,
    parcoursClients: state.parcoursClients.data,
    parametre: state.parametre.data,
    rubriques: state.rubriques.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Demandes);
